import React from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	useTheme
} from "@mui/material";

import beans from "../../../utils/assets/icons/beans2.png";
import soy from "../../../utils/assets/icons/soy.png";
import rice from "../../../utils/assets/icons/rice.png";
import question from "../../../utils/assets/icons/question.png";
import corn from "../../../utils/assets/icons/corn.png";

import styles from "./produtividade.module.css";
import { tokens } from "../../../theme";

const formaNumber = (number, decimals = 2) => {
	return Number(number || 0).toLocaleString("pt-br", {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals
	});
};

const iconDict = [
	{ cultura: "Feijão", icon: beans, alt: "feijao" },
	{ cultura: "Arroz", icon: rice, alt: "arroz" },
	{ cultura: "Soja", icon: soy, alt: "soja" },
	{ cultura: "Milho", icon: corn, alt: "milho" }
];

const filteredAlt = (data) => {
	const filtered = iconDict.filter((dictD) => dictD.cultura === data);
	if (filtered.length > 0) return filtered[0].alt;
	return "";
};

const filteredIcon = (data) => {
	const filtered = iconDict.filter((dictD) => dictD.cultura === data);
	if (filtered.length > 0) return filtered[0].icon;
	return question;
};

const MapResumePage = ({ data = [] }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	if (!Array.isArray(data) || data.length === 0) {
		return null;
	}

	const groupedData = data.reduce((acc, item) => {
		const cultura = item.cultura || "Não Definido";
		const variedade = item.variedade || "Não Definido";
		const area = Number(item.total_area_colheita || 0);

		if (!acc[cultura]) {
			acc[cultura] = { total: 0, variedades: [] };
		}

		acc[cultura].total += area;
		acc[cultura].variedades.push({
			...item,
			variedade,
			total_area_colheita: area
		});

		return acc;
	}, {});

	const orderedEntries = Object.entries(groupedData)
		.sort((a, b) => a[0].localeCompare(b[0], "pt-BR"))
		.map(([cultura, values]) => [
			cultura,
			{
				...values,
				variedades: [...values.variedades].sort((a, b) =>
					String(a.variedade || "").localeCompare(
						String(b.variedade || ""),
						"pt-BR"
					)
				)
			}
		]);

	return (
		<TableContainer
			sx={{
				maxWidth: "100%",
				margin: "auto",
				boxShadow: 8,
				borderRadius: "8px",
				padding: "0px"
			}}
		>
			<Table>
				<TableHead sx={{ backgroundColor: "transparent" }}>
					<TableRow sx={{ backgroundColor: "rgba(25,118,210,0.8)" }}>
						<TableCell
							sx={{
								color: "white",
								fontWeight: "bold",
								width: "100px",
								padding: "12px 5px 0px 5px!important",
								fontSize: "1.2em",
								borderRight: "none"
							}}
						>
							Cultura
						</TableCell>
						<TableCell
							sx={{
								color: "white",
								fontWeight: "bold",
								width: "100px",
								padding: "12px 5px 0px 5px !important",
								fontSize: "1.2em",
								borderRight: "none"
							}}
						>
							Variedade
						</TableCell>
						<TableCell
							sx={{
								color: "white",
								fontWeight: "bold",
								width: "100px",
								padding: "12px 5px 0px 5px !important",
								fontSize: "1.2em",
								textAlign: "right",
								borderRight: "none"
							}}
						>
							Área
						</TableCell>
					</TableRow>
				</TableHead>

				<TableBody>
					{orderedEntries.map(([cultura, { variedades, total }]) => (
						<React.Fragment key={cultura}>
							{variedades.map((variedade, index) => (
								<TableRow
									key={`${cultura}-${variedade.variedade}-${index}`}
									sx={{
										borderBottom: "1px solid rgba(224, 224, 224, 1)",
										"&:hover": { backgroundColor: "transparent" }
									}}
								>
									{index === 0 && (
										<TableCell
											rowSpan={variedades.length}
											sx={{
												fontWeight: "bold",
												verticalAlign: "middle",
												borderRight: "1px solid rgba(245,245,245,0.2)",
												padding: "7px 5px !important",
												color: "black"
											}}
										>
											<img
												className={styles.imgIconResume}
												src={filteredIcon(cultura)}
												alt={filteredAlt(cultura)}
											/>
											<p
												style={{
													fontSize: "1.2em",
													fontWeight: "bold",
													margin: 0,
													textAlign: "center"
												}}
											>
												{formaNumber(total, 0)} Há
											</p>
										</TableCell>
									)}

									<TableCell
										sx={{
											padding: "7px 5px !important",
											color: colors.grey[700],
											fontSize: "0.9em",
											fontWeight: "bold"
										}}
									>
										{variedade.variedade || "Não Definido"}
									</TableCell>

									<TableCell
										sx={{
											textAlign: "right",
											padding: "5px 5px !important",
											color: "black",
											fontWeight: "bold"
										}}
									>
										{formaNumber(variedade.total_area_colheita)}
									</TableCell>
								</TableRow>
							))}
						</React.Fragment>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default MapResumePage;